// extracted by mini-css-extract-plugin
export var chip = "_3u-0";
export var filterDropdown = "_3u-5";
export var filterItem = "_3u-6";
export var icon = "_3u-1";
export var removeButton = "_3u-3";
export var removeIcon = "_3u-4";
export var separator = "_3u-2";